// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__JDeav","button":"style_button__22Bma"};